import React from 'react'
import { Row, Col, Icon, Tooltip, Popconfirm } from 'antd'
import PropTypes from 'prop-types'
import Highlighter from 'react-highlight-words';
//Model

// Components
import ViewTable from '../../../Table/ViewTable'
import Button from '../../../Buttons'
import RowTools from "../../../Table/RowTools";
import helper from "../../../../helper/helper";
import CLNMModal from "../../ChatLuongXaThai/Modal";
import Api_tnn from '../../../../api/api.tnn'
import CVModal from "../../../ConvertExcel"
import typo from "../../../../constants/dictionaries"
import Input from "../../../Common/Input";
import Status from "../../../Table/Status/KetQuaQuanTrac"
export default class ChatLuongNuocMat extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      isAddModalOpen: false,
      isEditModalOpen: false,
      miningQuantity: [],
      selectedRow: null,
      searchText: '',
      searchedColumn: '',
      pickAll: [],
      selectedRowKeys: []
    }
  }
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={typo.cscore_search}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
          mandatory={false}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {typo.cscore_search}
        </Button>
        <Button type="primary" icon="reload" onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          {typo.cscore_lamMoi}
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Tooltip title="Lọc dữ liệu">
        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
      </Tooltip>
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
          text
        ),
  });
  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  handelOpenConvertExcel = () => {
    this.setState({
      isCVModalOpen: true
    })
  }

  handleOpenAddModal = () => {
    this.setState({
      isAddModalOpen: true
    })
  };

  handleOpenEditModal = (row) => {
    this.setState({
      selectedRow: row,
      isEditModalOpen: true
    })
  };

  handleShowDetail = (row) => {
    this.setState({
      selectedRow: row,
    })
  };

  handleCloseModal = () => {
    this.setState({
      isAddModalOpen: false,
      isEditModalOpen: false,
      selectedRow: null
    })
  };
  handleCloseModalCV = (data, user) => {
    this.setState({
      isCVModalOpen: false,
    })
    if (data.length > 0) {
      new Api_tnn().DeleteExcelKQQT({ token: user.access_token, filename: data[0].fileName })
    }
  }
  handleAddCV = (item, file, user) => {
    const { dataSource, handleUpdate } = this.props;
    const newData = [...dataSource, ...item];
    if (file.length > 0) {
      new Api_tnn().DeleteExcelKQQT({ token: user.access_token, filename: file[0].fileName })
    }
    handleUpdate(newData);
  }

  handleAdd = (item) => {
    const { dataSource, handleUpdate } = this.props;
    const newData = [...dataSource, { ...item, daXoa: 0 }];
    this.handleCloseModal();
    handleUpdate(newData);
  };

  handleEdit = (item) => {
    const { dataSource, handleUpdate, field } = this.props;
    const newData = helper.replaceItem(item, dataSource, "stt");
    this.handleCloseModal();
    handleUpdate(newData, field);
  };

  handleDelete = (item) => {
    const { dataSource, handleUpdate, field, isEdit } = this.props;
    const newData = helper.updateArray(item, dataSource, isEdit)
    handleUpdate(newData, field);
  };
  deletaAll = () => {
    const { pickAll } = this.state
    if (pickAll && pickAll.length > 0) {
      pickAll.map((value, index) => {
        this.handleDelete(value)
      })
      this.setState({ selectedRowKeys: [], pickAll: [] })
    }
  }

  addSttToItems = (items) => {
    if (!items) return [];
    let newItems = [];
    if (items) {
      items.map((value, index) => ({ ...value, key: index + 1 }))
      newItems = items.filter(item => item.daXoa === 0)
    }
    return newItems;
  };

  render() {
    const { isAddModalOpen, isEditModalOpen, selectedRow, isCVModalOpen, pickAll, selectedRowKeys } = this.state;
    const { dataSource, mode, idGiayPhep, dataChatLuong, doiTuongQT } = this.props;
    // Columns
    const columns_form = [
      {
        title: "#",
        dataIndex: "stt",
        width: "55px",
      },
      {
        title: "Vị trí quan trắc",
        dataIndex: "ten_tramquantrac",
        width: "25%",
        key: "mau_ten",
        ...this.getColumnSearchProps('mau_ten')
      },
      {
        title: "Tên đợt quan trắc",
        dataIndex: "dotquantrac_ten",
        key: "mau_ten",
        ...this.getColumnSearchProps('mau_ten')
      },
      {
        title: "Đợt quan trắc số",
        dataIndex: "dotquantrac",
        key: "mau_ten",
        ...this.getColumnSearchProps('mau_ten')
      },
      {
        title: "Trạng thái",
        dataIndex: "ketqua_danhgia",
        width: 130,
        render: (value, row) => (
          <Tooltip title={row.thongso_vuotnguongs}>
            <div>
              <Status value={value} trangthai={value} />
            </div>
          </Tooltip>
        )
      },
      {
        title: "Thao tác",
        render: (value, row) => (
          <RowTools
            row={row}
            iconDelete={mode === 'view' ? true : false}
            iconEdit={mode === 'view' ? true : false}
            iconDetail={mode === 'view' ? true : false}
            deleteRowModal={() => this.handleDelete(row)}
            showEditModal={() => this.handleOpenEditModal(row)}
            showDetail={() => this.handleOpenEditModal(row)}
          />
        ),
        width: "80px"
      },
    ];
    const rowSelection = {
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys: selectedRowKeys, pickAll: selectedRows })
      },
    };
    return (
      <Row>
        {mode !== "view" &&
          <Row type="flex" justify="space-between" align="middle">
            <div>
              {pickAll && pickAll.length > 0 &&
                <Tooltip title="Xóa các vị trí quan trắc đã được chọn" placement="bottom">
                  <Popconfirm placement="top" title="Bạn chắc chắn muốn xóa tất cả các vị trí quan trắc đã chọn"
                    onConfirm={() => this.deletaAll()}
                    onCancel={() => undefined}
                    okText="Chắc chắn" cancelText="Không">
                    <Button type="primary">
                      <Icon type="delete" />Xóa tất cả
                      </Button>
                  </Popconfirm>
                </Tooltip>}
            </div>
            <div>
              <Button type="excel" onClick={this.handelOpenConvertExcel}><Icon type="file-excel" />{typo.cscore_convertExcel}</Button>
              <Button type="primary" onClick={this.handleOpenAddModal} icon="plus" style={{ marginLeft: "10px" }} />
            </div>
          </Row>
        }
        <div className="mt-10" />
        <div style={{ maxHeight: "350px", overflowY: "auto" }}>
          <ViewTable
            bordered pagination={false}
            columns={columns_form}
            dataSource={this.addSttToItems(dataSource)}
            rowSelection={rowSelection}
          />
        </div>
        <span style={{ fontSize: "13px", color: "#000", fontWeight: "600" }}>Tổng số: {dataSource.length}</span>

        {isAddModalOpen &&
          <CLNMModal
            mode="add"
            isOpen={isAddModalOpen}
            handleCancel={this.handleCloseModal}
            handleOk={this.handleAdd}
            idGiayPhep={idGiayPhep}
            dataChatLuong={dataChatLuong}
            doiTuongQT={doiTuongQT}
          />}

        {isEditModalOpen &&
          <CLNMModal
            mode="edit"
            view={mode}
            initialValues={selectedRow}
            isOpen={isEditModalOpen}
            handleCancel={this.handleCloseModal}
            handleOk={this.handleEdit}
            isEdit={true}
            idGiayPhep={idGiayPhep}
            doiTuongQT={doiTuongQT}
          />}
        {isCVModalOpen &&
          <CVModal
            isOpen={isCVModalOpen}
            handleCancel={this.handleCloseModalCV}
            handleAdd={this.handleAddCV}
            doiTuongQT={doiTuongQT}
            idGiayPhep={idGiayPhep}
          />}
      </Row>
    )
  }
}

ChatLuongNuocMat.propTypes = {
  // MODE: string "form" and "presentation"
  mode: PropTypes.string.isRequired,
  dataSource: PropTypes.array.isRequired,
  handleUpdate: PropTypes.func,
};